import { Http } from '@mygpt/app/http';

export interface GetTokenParams {
  code: string;
}

/**
 * 获取token
 * @param params
 * @returns
 */
export const getToken = (params: GetTokenParams) => {
  const { ...rest } = params;
  const { post } = Http.use();
  return post(`/oauth/token`, rest);
};

export interface RefreshTokenParams {
  refresh_token: string;
}

/**
 * 刷新token
 * @param params
 * @returns
 */
export const refreshToken = (params: RefreshTokenParams) => {
  const { ...rest } = params;
  const { post } = Http.use();
  return post(`/oauth/token/refresh`, rest);
};

/** End the server session before callers remove their browser credentials. */
export const revokeSession = (accessToken?: string) => {
  if (!accessToken) return Promise.resolve();
  const { post } = Http.use();
  return post<void>('/logout', undefined, {
    timeout: 5000,
    skipErrorNotification: true,
    headers: { Authorization: /^Bearer\s/i.test(accessToken) ? accessToken : `Bearer ${accessToken}` },
  });
};
